module.exports = __webpack_public_path__ + "img/zidonghuawang.81925012.png";